import {api} from "./api.service";

export const GetQuaterlyTargets = async (
    quarter = "1",
    year = "2024",
    category = '',
) => {
    const params = {};

    if (quarter) {
        params["quarter"] =quarter;
    }

    if (year) {
        params["year"] = year;
    }

    if (category) {
        params["category"] = category;
    }


    let res = await api.get("quarterly-targets", { params });
    return res;
};

export const GetGoalsCategory = async (param) => {
    let res = await api.get("goals", { params: param });
    return res;
};


export const AddGoals = async (data) => {
    let res = await api.post(`goals`, data);
    return res;
};


export const UpdateGoals = (id, data) => {
    return  api.patch(`goals/${id}`,data);
}
